<template>
  <v-card>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="items"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.student_invoice_id="{ item }">
        <span class="table-complete-name">QSL_{{item.student_invoice_id}}</span>
      </template>

      <template v-slot:item.name="{ item }">
        <span class="table-complete-name">{{item.name}}</span>
      </template>

      <template v-slot:item.total_hours="{ item }">
        <span class="table-complete-name"> {{item.total_hours}}</span>
      </template>

      <template v-slot:item.amount="{ item }">
        <span class="table-complete-name">£ {{item.amount}}</span>
      </template>

      <template v-slot:item.student_invoice_status="{item}">
        <span v-if="item.student_invoice_status == 'paid'">{{item.student_invoice_status}}</span>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span
          :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{items.length}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import DataTableMixin from "../../../mixins/dataTable";

export default {
  name: "PaidTable",
  components: {},
  mixins: [DataTableMixin],
  data() {
    return {
      loading:true,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        { text: "Srno.", sortable: true, value: "student_invoice_id" },
        { text: "Student Name", value: "student.full_name", sortable: true },
        { text: "Total Hours", value: "total_hours", sortable: false },
        { text: "Amount", value: "amount", sortable: false },
        { text: "Status", value: "student_invoice_status", sortable: false }
      ],
    };
  },
  methods: {
    makeQueryParams(){
      const user = JSON.parse(localStorage.getItem("user"));

      return {
        ...this.formQueryParams(),
        tutor:user.id,
        status: 2
      }
    },
    // getItems(){
    //   this.loading=true
    //   axios.get(apiRoutes.accounts.invoices.students.url,{
    //     params:{
    //       type : 'cleared'
    //     }
    //   }).then(response=>{
    //     this.loading = false
    //     this.formalizeTable(response.data)
    //   })
    // }
       getItems(){
      this.loading=true
      axios.get(apiRoutes.accounts.invoices.students.getStudentInvoice,{
        params:{
          type : 'paid',
          // username :  user.username
        }
      }).then(response=>{
        // console.log(response.data.response);
        this.loading = false;
    this.items=response.data.response;
      })
    }
  },
  mounted() {

    this.getItems()
  }
};
</script>
<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-status {
    font: 600 14px/17px Gotham;
    color: #129b11;

    &.st-error {
      color: #e41b1bf7;
    }
  }
}
</style>